import { Controller } from "@hotwired/stimulus"

const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "live.com",
  "msn.com", "aol.com", "proton.me", "protonmail.com", "icloud.com",
  "yandex.com", "zoho.com", "test.com"
])

export default class extends Controller {
  static targets = [
    "nameInput",    "nameError",
    "emailInput",   "emailError",
    "designationInput", "designationError",
    "messageInput", "messageError"
  ]

  validateName() {
    const val = this.nameInputTarget.value.trim()
    if (!val) {
      this.#showError(this.nameInputTarget, this.nameErrorTarget, "Name is required")
    } else {
      this.#clearError(this.nameInputTarget, this.nameErrorTarget)
    }
  }

  validateEmail() {
    const val = this.emailInputTarget.value.trim()
    if (!val) {
      this.#showError(this.emailInputTarget, this.emailErrorTarget, "Email is required")
      return
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      this.#showError(this.emailInputTarget, this.emailErrorTarget, "Enter a valid email address")
      return
    }
    const domain = val.split("@")[1]?.toLowerCase()
    if (FREE_EMAIL_DOMAINS.has(domain)) {
      this.#showError(this.emailInputTarget, this.emailErrorTarget, "Please use your company email")
    } else {
      this.#clearError(this.emailInputTarget, this.emailErrorTarget)
    }
  }

  validateDesignation() {
    const val = this.designationInputTarget.value.trim()
    if (!val) {
      this.#showError(this.designationInputTarget, this.designationErrorTarget, "Designation is required")
    } else {
      this.#clearError(this.designationInputTarget, this.designationErrorTarget)
    }
  }

  validateMessage() {
    const val = this.messageInputTarget.value.trim()
    const wordCount = val ? val.split(/\s+/).filter(Boolean).length : 0
    if (!val) {
      this.#showError(this.messageInputTarget, this.messageErrorTarget, "Project brief is required")
    } else if (wordCount > 200) {
      this.#showError(this.messageInputTarget, this.messageErrorTarget, `Too long: ${wordCount}/200 words`)
    } else {
      this.#clearError(this.messageInputTarget, this.messageErrorTarget)
    }
  }

  submit(event) {
    this.validateName()
    this.validateEmail()
    this.validateDesignation()
    this.validateMessage()

    const errorTargets = [this.nameErrorTarget, this.emailErrorTarget, this.designationErrorTarget, this.messageErrorTarget]
    const hasErrors = errorTargets.some(el => !el.classList.contains("hidden"))

    if (hasErrors) {
      event.preventDefault()
      const inputs = [this.nameInputTarget, this.emailInputTarget, this.designationInputTarget, this.messageInputTarget]
      const firstInvalid = inputs.find(el => el.classList.contains("border-red-500"))
      firstInvalid?.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  #showError(input, errorEl, message) {
    errorEl.textContent = message
    errorEl.classList.remove("hidden")
    input.classList.add("border-red-500")
    input.classList.remove("border-slate-200")
  }

  #clearError(input, errorEl) {
    errorEl.textContent = ""
    errorEl.classList.add("hidden")
    input.classList.remove("border-red-500")
    input.classList.add("border-slate-200")
  }
}
